const MEETING_BROKER_ORIGINS = [
  'https://recesshotelsavannah.meetingbroker.com',
  'https://www.recesshotelsavannah.meetingbroker.com',
];

let messageListenerAttached = false;

function isMeetingBrokerOrigin(origin) {
  return MEETING_BROKER_ORIGINS.includes(origin);
}

function pushGtmEvent(data) {
  if (!data || !data.event) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    src: data.src,
    event: data.event,
    eventData: {
      event_source: data.eventData?.event_source,
      method: data.eventData?.method,
      form_type: data.eventData?.form_type,
      step: data.eventData?.step,
    },
  });
}

function handleSuccess() {
  const meetingBroker = document.querySelector('.meeting-broker');

  if (meetingBroker) {
    meetingBroker.classList.add('meeting-broker--success');
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function handleMessage(event) {
  if (!isMeetingBrokerOrigin(event.origin)) {
    return;
  }

  if (event.data && event.data.rfpFormStatus === 'success') {
    handleSuccess();
    return;
  }

  if (typeof event.data === 'string' && event.data.startsWith('{')) {
    try {
      pushGtmEvent(JSON.parse(event.data));
    } catch (error) {
      // Ignore invalid JSON payloads from third-party iframe.
    }
  }
}

function initAll() {
  if (messageListenerAttached) {
    return;
  }

  if (!document.querySelector('.meeting-broker')) {
    return;
  }

  window.addEventListener('message', handleMessage, false);
  messageListenerAttached = true;
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-meeting-broker', initAll);
  }

  initAll();
});
